import React, { useMemo } from 'react';
import { TrainingOptionItemProps } from './Types';
import CustomSubTitle from '../CustomSubTitle';
import CustomMaskIcon from '../../common/CustomMaskIcon';

const getAlignmentClass = (alignment?: string) => {
  switch (alignment) {
    case 'left':
      return 'items-start';
    case 'right':
      return 'items-end';
    case 'center':
    default:
      return 'items-center';
  }
};

const TrainingOptionItem = ({
  iconUrl,
  text,
  optionAlignment,
  optionMobileAlignment,
  optionIconColor = '#fff',
  optionTextColor = '#fff',
}: TrainingOptionItemProps) => {
  const desktopAlignmentClass = useMemo(
    () => getAlignmentClass(optionAlignment),
    [optionAlignment],
  );
  const mobileAlignmentClass = useMemo(
    () => getAlignmentClass(optionMobileAlignment ?? optionAlignment),
    [optionMobileAlignment, optionAlignment],
  );

  return (
    <div
      className={`flex flex-col ${mobileAlignmentClass} sm:${desktopAlignmentClass}`}
    >
      <div className="relative w-12 h-12 mb-3">
        <CustomMaskIcon
          url={iconUrl}
          alt={text}
          color={optionIconColor}
          width={48}
          height={48}
          className="w-full h-full"
        />
      </div>
      <CustomSubTitle
        subtitle={text}
        subTitleStyle={{
          color: optionTextColor,
          alignment: optionAlignment,
          fontFamily: 'Source Sans 3',
          fontWeight: 500,
          fontSize: '16px',
          lineHeight: '100%',
          letterSpacing: '0%',
        }}
      />
    </div>
  );
};

export default TrainingOptionItem;
